<template>
    <section name="association section" class="gap-md col-span-8 flex flex-col">
        <div class="gap-sm flex w-full">
            <button
                class="flex cursor-pointer p-0"
                aria-label="Go back to the previous page"
                style="padding-top: 2px"
                @click="$emit('cancel')"
            >
                <i class="i-arrow-left h-6 w-6" />
            </button>
            <h1>Edit {{ type }} connection</h1>
        </div>

        <CascadingLocationsUuid
            v-if="type === 'location'"
            :items="itemPool as UUIDLocation[]"
            :associated-items="associatedItems as UUIDLocation[]"
            :editable="true"
            :expand-all="true"
            @update="onUpdate"
        />

        <div class="gap-sm flex">
            <Button @click="onSave">Save</Button>
            <Button variant="secondary" @click="$emit('cancel')">Cancel</Button>
        </div>
    </section>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { shallowRef } from 'vue';
import type { UUIDLocation } from '@/stores/store-interfaces';

import CascadingLocationsUuid from '../misc/cascading-locations-uuid.vue';

const emit = defineEmits(['save', 'cancel']);
const checkedItems = shallowRef<Set<string>>(new Set()); // location uuids strings

defineProps({
    type: {
        type: String,
        required: true,
    },
    associatedItems: {
        type: Array as () => UUIDLocation[],
        required: true,
    },
    itemPool: {
        type: Array as () => UUIDLocation[],
        required: true,
    },
});

function onUpdate(next: Set<string>) {
    // console.log('[AssociationComp] update', { size: next.size, ids: Array.from(next) });
    checkedItems.value = next;
}

function onSave() {
    // console.log('[AssociationComp] save', {
    // size: checkedItems.value.size,
    // ids: Array.from(checkedItems.value),
    // });
    emit('save', checkedItems.value);
}
</script>
